module.exports = __webpack_public_path__ + "img/quest_icon_0005_chest.9d14c815.png";